module.exports = __webpack_public_path__ + "static/img/heinestrasse.41db7d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/WED_Heinestraße/heinestrasse.jpg
// module id = CDGV
// module chunks = 0